import { EventMetadata } from '~analytics/EventMetadata';
import { EventTypes } from '~analytics/types';

export const launchQuizEventMetadata: EventMetadata = {
  name: EventTypes.LaunchQuiz,
  description: 'A teacher launched a quiz activity into a room.',
  category: 'Activity',
  platform: 'client',
  status: 'active',
  properties: {
    room_type: {
      type: 'enum',
      values: ['rostered_room', 'open_room'],
      description:
        'Whether the quiz was launched into a rostered or open room.',
      required: true,
    },
    delivery_method: {
      type: 'enum',
      values: ['instant_feedback', 'open_navigation', 'teacher_paced'],
      description: 'Pacing selected for the activity.',
      required: true,
    },
    activity_require_names: {
      type: 'boolean',
      description: 'Students must enter their name before joining.',
      required: true,
    },
    activity_shuffle_questions: {
      type: 'boolean',
      description: 'Questions are presented to students in a randomised order.',
      required: true,
    },
    activity_shuffle_answers: {
      type: 'boolean',
      description:
        'Multiple-choice answers are presented in a randomised order.',
      required: true,
    },
    activity_show_question_feedback: {
      type: 'boolean',
      description: 'Students see per-question feedback after answering.',
      required: true,
    },
    activity_show_final_score: {
      type: 'boolean',
      description: 'Students see their final score at the end of the activity.',
      required: true,
    },
    activity_one_attempt: {
      type: 'boolean',
      description: 'Students are restricted to a single attempt.',
      required: true,
    },
    activity_timer_duration_seconds: {
      type: 'number',
      description:
        'Length of the quiz timer in seconds, or null if no timer is set.',
      required: true,
    },
    launch_route: {
      type: 'string',
      description:
        'UI entry point the teacher launched from (see LaunchRoute).',
      required: true,
    },
    workspace_id: {
      type: 'string',
      description: 'Workspace the quiz was launched from, if applicable.',
      required: false,
    },
    workspace_quiz_id: {
      type: 'string',
      description:
        'Workspace quiz identifier, if the quiz originated in a workspace.',
      required: false,
    },
  },
};
